import React from "react";

const NewBackIcon = ({ width, height, color }) => {
  return (
    <svg
    width={width ? width : "31"}
    height={height ? height : "31"}
    
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M46.6239 22H50.6919C53.2839 22 55.2099 20.902 55.2099 18.544C55.2099 16.96 54.2559 16.042 52.9599 15.754V15.682C53.9859 15.322 54.5979 14.242 54.5979 13.126C54.5979 10.966 52.8159 10.228 50.3859 10.228H46.6239V22ZM48.7119 15.088V11.848H50.2419C51.7719 11.848 52.5459 12.28 52.5459 13.432C52.5459 14.44 51.8439 15.088 50.2059 15.088H48.7119ZM48.7119 20.38V16.654H50.4759C52.2399 16.654 53.1759 17.194 53.1759 18.436C53.1759 19.75 52.2039 20.38 50.4759 20.38H48.7119ZM59.3261 22.216C60.3701 22.216 61.2701 21.694 62.0621 21.028H62.1341L62.2781 22H63.9881V16.762C63.9881 14.296 62.8901 12.946 60.6941 12.946C59.2901 12.946 58.0301 13.486 57.0581 14.098L57.8141 15.484C58.6061 15.016 59.4341 14.62 60.2981 14.62C61.5041 14.62 61.8821 15.412 61.9181 16.348C58.2821 16.744 56.7161 17.734 56.7161 19.624C56.7161 21.172 57.7781 22.216 59.3261 22.216ZM59.9921 20.596C59.2541 20.596 58.7141 20.254 58.7141 19.462C58.7141 18.58 59.5061 17.95 61.9181 17.644V19.624C61.2521 20.236 60.7121 20.596 59.9921 20.596ZM70.1554 22.216C71.1634 22.216 72.2074 21.856 73.0354 21.136L72.1894 19.768C71.6854 20.182 71.0554 20.524 70.3714 20.524C68.9854 20.524 68.0134 19.354 68.0134 17.59C68.0134 15.808 69.0034 14.638 70.4254 14.638C70.9834 14.638 71.4334 14.872 71.9014 15.286L72.9094 13.936C72.2614 13.378 71.4514 12.946 70.3174 12.946C67.9594 12.946 65.8894 14.638 65.8894 17.59C65.8894 20.524 67.7434 22.216 70.1554 22.216ZM74.7798 22H76.8138V19.75L78.1998 18.166L80.4678 22H82.7178L79.3878 16.762L82.4118 13.162H80.1438L76.8678 17.23H76.8138V9.292H74.7798V22Z"
      fill="#303030"
    />
    <circle cx="15" cy="15" r="15" fill="#00008B" />
    <g clipPath="url(#clip0_520_12936)">
      <path
        d="M23.9476 21.1217C23.8219 21.1217 23.7035 21.0511 23.6454 20.935C23.626 20.8974 22.0773 18.0259 15.6147 17.9282V20.7839C15.6147 20.9126 15.5415 21.03 15.4262 21.0868C15.311 21.1435 15.1738 21.1303 15.0712 21.0522L7.98997 15.6254C7.90651 15.5614 7.85718 15.4624 7.85718 15.3575C7.85718 15.2521 7.90651 15.1531 7.98997 15.089L15.0715 9.66242C15.1742 9.58407 15.3113 9.57083 15.4265 9.62731C15.5418 9.68368 15.615 9.80164 15.615 9.92998V12.9394C15.786 12.9286 16.0086 12.9191 16.2714 12.9191C18.6812 12.9191 24.2857 13.6857 24.2857 20.7832C24.2857 20.9402 24.1778 21.0768 24.0248 21.1124C23.999 21.1191 23.9736 21.1217 23.9476 21.1217Z"
        fill="white"
      />
      <path
        d="M13.5715 8.92868L6.63502 14.604C6.15438 14.9972 6.14464 15.7289 6.61463 16.1348L13.5715 22.143"
        stroke="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_520_12936">
        <rect
          width="19.2857"
          height="16.4286"
          fill="white"
          transform="translate(5 7.14294)"
        />
      </clipPath>
    </defs>
  </svg>
  );
};
export default NewBackIcon;
